import { swRequest } from "@sourcewhale/core";

export const getUploadsNotifications = () =>
  swRequest({
    path: "/api/uploads_notifications/get",
    method: "GET",
  });

export const updateUploadsNotifications = (body) =>
  swRequest({
    path: "/api/uploads_notifications/modify",
    method: "POST",
    body,
  });
